import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import { CookieStorage } from "redux-persist-cookie-storage";
import Cookies from "cookies-js";

import reducer from "../Reducers/index";

const persistConfig = {
  key: "root",
  storage: new CookieStorage(Cookies, {}),
};

const persistorReducer = persistReducer(persistConfig, reducer);
export const store = createStore(persistorReducer, applyMiddleware(thunk));
export const persistor = persistStore(store);

export default (store, persistor);
